export function resolveUnlimitedAnonymousProjects(isOnline: boolean, configuredValue: boolean) {
  return !isOnline && configuredValue;
}
